<template>
<div>
    <trademark-form ref="trademarkForm"></trademark-form>
    <div class="custom-search">
        <b-row class="align-items-center mb-1">
            <b-col class="col-md-2">
                <label for="trademark-objection-to-us-date-start-input">{{ $t('trademarkObjectionToUsReport.objection_to_us_date_start') }}</label>
                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('trademarkObjectionToUsReport.objection_to_us_date_start')" size="sm" v-model="objectionToUsDateStart" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-col>
            <b-col class="col-md-2">
                <label for="trademark-objection-to-us-date-end-input">{{ $t('trademarkObjectionToUsReport.objection_to_us_date_end') }}</label>
                <b-form-datepicker today-button :label-today-button="$t('dateTime.today')" :placeholder="$t('trademarkObjectionToUsReport.objection_to_us_date_end')" size="sm" v-model="objectionToUsDateEnd" class="mb1" defaultDate: null reset-button :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
            </b-col>
            <b-col class="col-md-2">
                <label for="trademark-objection-to-us-owner-name-input">{{ $t('trademarkObjectionToUsReport.objection_to_us_owner') }}</label>
                <div class="d-flex align-items-center">
                    <b-form-input size="sm" v-model="objectionToUsOwner" v-on:keyup.enter="getTrademarkObjectionToUsReportList()" :placeholder="$t('trademarkObjectionToUsReport.objection_to_us_owner')" type="text" class="d-inline-block" />
                </div>
            </b-col>
            <b-col class="col-md-2">
                <label for="trademark-objection-to-us-trademark-agent-input">{{ $t('trademarkObjectionToUsReport.opposed_trademark_agent') }}</label>
                <div class="d-flex align-items-center">
                    <b-form-input size="sm" v-model="opposedTrademarkAgentName" v-on:keyup.enter="getTrademarkObjectionToUsReportList()" :placeholder="$t('trademarkObjectionToUsReport.opposed_trademark_agent')" type="text" class="d-inline-block" />
                </div>
            </b-col>
            <b-col class="col-md-2">
                <label for="trademark-objection-to-us-trademark-owner-input">{{ $t('trademarkObjectionToUsReport.opposed_trademark_owner') }}</label>
                <div class="d-flex align-items-center">
                    <b-form-input size="sm" v-model="opposedTrademarkOwnerName" v-on:keyup.enter="getTrademarkObjectionToUsReportList()" :placeholder="$t('trademarkObjectionToUsReport.opposed_trademark_owner')" type="text" class="d-inline-block" />
                </div>
            </b-col>

            <b-col class="col-md-2  mt-2 custom-search d-flex justify-content-end">
                <b-button style="float:right;" class="d-inline-block mr-05" size="sm" variant="outline-primary" v-on:keyup.enter="getTrademarkObjectionToUsReportList()" @click="getTrademarkObjectionToUsReportList()">{{ $t('others.list') }}</b-button>
                <b-button style="float:right;" class="d-inline-block" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
            </b-col>
        </b-row>
    </div>
    <!-- table -->
    <vue-good-table id="trademarkObjectionToUsReportTable" ref="trademarkObjectionToUsReportTable" :columns="columns" :rows="rows" :search-options="{
                enabled: true,
                externalQuery: searchTerm,
              }" styleClass="vgt-table condensed tableSize" :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }" :pagination-options="{
            enabled: true,
            perPage: pageLength
          }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'opposedTrademarkReferenceNo'" class="text-nowrap">
                {{ $t('trademarkObjectionToUsReport.opposed_trademark_reference_no') }}
            </span>
            <span v-else-if="props.column.field === 'opposedTrademarkNiceClass'" class="text-nowrap">
                {{ $t('trademarkObjectionToUsReport.opposed_trademark_nice_class') }}
            </span>
            <span v-else-if="props.column.field === 'trademarkObjectionToUsDate'" class="text-nowrap">
                {{ $t('trademarkObjectionToUsReport.trademark_objection_date') }}
            </span>
            <span v-else-if="props.column.field === 'objectionToUsOwner'" class="text-nowrap">
                {{ $t('trademarkObjectionToUsReport.objection_to_us_owner') }}
            </span>
            <span v-else-if="props.column.field === 'groundOfObjection'" class="text-nowrap">
                {{ $t('trademarkObjectionToUsReport.ground_of_objection') }}
            </span>
            <span v-else-if="props.column.field === 'opposedTrademark'" class="text-nowrap">
                {{ $t('trademarkObjectionToUsReport.opposed_trademark_name') }}
            </span>
            <span v-else-if="props.column.field === 'opposedTrademarkAgent'" class="text-nowrap">
                {{ $t('trademarkObjectionToUsReport.opposed_trademark_agent') }}
            </span>
            <span v-else-if="props.column.field === 'opposedTrademarkOwnerList'" class="text-nowrap">
                {{ $t('trademarkObjectionToUsReport.opposed_trademark_owner') }}
            </span>
            <span v-else-if="props.column.field === 'oppositionStatus'" class="text-nowrap">
                {{ $t('trademarkObjectionToUsReport.opposition_status') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.view_record')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.opposedTrademarkId)">
                        <feather-icon icon="EyeIcon" />
                    </b-button>
                </span>
            </span>
            <span v-else-if="props.column.field === 'opposedTrademarkOwnerList'">
                <b-col>
                    <b-row v-for="owner in props.row.opposedTrademarkOwnerList" v-bind:key="owner.id" style="font-size: small;">
                        <tr v-if="props.row.opposedTrademarkOwnerList.length != 1">
                            <feather-icon class="featherIconReSize" icon="ArrowRightIcon" />
                            <span>{{ owner.clientName }} </span> <br />
                        </tr>
                        <tr v-else-if="props.row.opposedTrademarkOwnerList.length == 1">
                            <span>{{ owner.clientName }} </span> <br />
                        </tr>
                    </b-row>
                </b-col>
            </span>
        </template>
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}</span>
                    <b-form-select size="sm" v-model="pageLength" :options="['10','50','100']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <!-- ,'100', '1000' -->
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getTrademarkObjectionToUsReportList()">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        trademarkId: Number,
    },
    data() {
        return {
            dir: false,
            columns: [{
                    label: this.$t('trademarkObjectionToUsReport.opposed_trademark_reference_no'),
                    field: 'opposedTrademarkReferenceNo',
                },
                {
                    label: this.$t('trademarkObjectionToUsReport.opposed_trademark_nice_class'),
                    field: 'opposedTrademarkNiceClass',
                },
                {
                    label: this.$t('trademarkObjectionToUsReport.trademark_objection_date'),
                    field: 'trademarkObjectionToUsDate',
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('trademarkObjectionToUsReport.objection_to_us_owner'),
                    field: 'objectionToUsOwner',
                },
                {
                    label: this.$t('trademarkObjectionToUsReport.ground_of_objection'),
                    field: 'groundOfObjection',
                },
                {
                    label: this.$t('trademarkObjectionToUsReport.opposed_trademark_name'),
                    field: 'opposedTrademark',
                },
                {
                    label: this.$t('trademarkObjectionToUsReport.opposed_trademark_agent'),
                    field: 'opposedTrademarkAgent',
                },
                {
                    label: this.$t('trademarkObjectionToUsReport.opposed_trademark_owner'),
                    field: 'opposedTrademarkOwnerList',
                },
                {
                    label: this.$t('trademarkObjectionToUsReport.opposition_status'),
                    field: 'oppositionStatus',
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '10em'
                },
            ],
            rows: [],
            searchTerm: '',
            pageLength: 10,
            pageNo: 1,
            total: 0,
            opposedTrademarkAgentName: '',
            opposedTrademarkOwnerName: '',
            objectionToUsOwner: '',
            objectionToUsDateStart: null,
            objectionToUsDateEnd: null,
        }
    },
    watch: {
        objectionToUsDateEnd(newValue) {
            if (newValue == '') {
                this.objectionToUsDateEnd = null
            }
        },
        objectionToUsDateStart(newValue) {
            if (newValue == '') {
                this.objectionToUsDateStart = null
            }
        },
    },
    mounted() {
        this.objectionToUsDateEnd = null,
            this.objectionToUsDateStart = null,
            this.opposedTrademarkAgentName = '',
            this.opposedTrademarkOwnerName = '',
            this.objectionToUsOwner = '',
            this.getTrademarkObjectionToUsReportList()
    },
    methods: {
        async getInfo(trademarkId) {
            this.$refs.trademarkForm.showInfo(trademarkId)
        },
        getTrademarkObjectionToUsReportList() {
            this.rows = []
            const data = {
                objectionToUsDateStart: this.objectionToUsDateStart,
                objectionToUsDateEnd: this.objectionToUsDateEnd,
                objectionToUsOwner: this.objectionToUsOwner,
                opposedTrademarkAgentName: this.opposedTrademarkAgentName,
                opposedTrademarkOwnerName: this.opposedTrademarkOwnerName,
                pageLength: this.pageLength,
                pageNo: this.pageNo
            }
            const controller = {
                name: 'TrademarkObjectionToUs',
                actionName: 'GetTrademarkObjectionToUsReport'
            }
            const payload = {
                controller: controller,
                data: data
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.rows = response.data.trademarkObjectionToUsReportList
                    this.total = response.data.total
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                    loader.hide()
                }
                loader.hide()
            })
        },
        exportExcel() {
            var controller = {
                name: 'TrademarkObjectionToUs',
                actionName: 'CanExport'
            }
            var data = {
                columnList: this.columns,
                dataList: this.rows
            }
            var payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Trademark Objection To Us Report", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
    },
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
